export default "__VITE_ASSET__BWBAduUi__"